module.exports = __webpack_public_path__ + "static/media/menu.823884e7.svg";